import * as React from "react";

function GoogleSvg(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={91.531}
      height={30.131}
      {...props}
    >
      <defs>
        <style>{".prefix__a{fill:#ea4335}.prefix__c{fill:#4285f4}"}</style>
      </defs>
      <path
        className="prefix__a"
        d="M39.17 15.856a7.553 7.553 0 11-7.556-7.529 7.436 7.436 0 017.556 7.529zm-3.306 0a4.258 4.258 0 10-8.493 0 4.258 4.258 0 108.493 0z"
      />
      <path
        d="M55.464 15.856a7.553 7.553 0 11-7.556-7.529 7.436 7.436 0 017.556 7.529zm-3.306 0a4.258 4.258 0 10-8.493 0 4.258 4.258 0 108.493 0z"
        fill="#fbbc05"
      />
      <path
        className="prefix__c"
        d="M71.079 8.782v13.517c0 5.56-3.279 7.831-7.156 7.831a7.17 7.17 0 01-6.674-4.437l2.879-1.2a4.159 4.159 0 003.787 2.674c2.481 0 4.019-1.531 4.019-4.413v-1.083h-.115a5.126 5.126 0 01-3.965 1.711 7.534 7.534 0 010-15.055 5.218 5.218 0 013.965 1.684h.115V8.785h3.14zm-2.906 7.1c0-2.651-1.769-4.589-4.019-4.589a4.354 4.354 0 00-4.192 4.589 4.321 4.321 0 004.192 4.535c2.25.001 4.019-1.91 4.019-4.534z"
      />
      <path d="M76.256.859v22.065h-3.225V.859z" fill="#34a853" />
      <path
        className="prefix__a"
        d="M88.822 18.333l2.566 1.711a7.494 7.494 0 01-6.273 3.337 7.367 7.367 0 01-7.471-7.529 7.155 7.155 0 017.1-7.529 6.993 6.993 0 016.443 4.79l.343.855-10.064 4.165a3.832 3.832 0 003.649 2.281 4.3 4.3 0 003.707-2.081zm-7.9-2.709l6.732-2.791a2.915 2.915 0 00-2.794-1.6 4.13 4.13 0 00-3.937 4.392z"
      />
      <path
        className="prefix__c"
        d="M11.857 13.897v-3.194h10.764a10.584 10.584 0 01.16 1.928 10.549 10.549 0 01-2.767 7.471 10.691 10.691 0 01-8.154 3.279A11.855 11.855 0 010 11.691 11.855 11.855 0 0111.861 0a11.14 11.14 0 018.011 3.221l-2.254 2.254a8.142 8.142 0 00-5.761-2.281 8.386 8.386 0 00-8.385 8.5 8.386 8.386 0 008.385 8.5 7.821 7.821 0 005.9-2.339 6.621 6.621 0 001.731-3.955z"
      />
    </svg>
  );
}

export default GoogleSvg;
